import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
const DIMENSIONS = [{
  label: 'Data foundations',
  value: 84,
  colour: '#FF5C1A'
}, {
  label: 'Skills and literacy',
  value: 66,
  colour: '#FF8A5C'
}, {
  label: 'Governance',
  value: 41,
  colour: '#7E93AE'
}, {
  label: 'Budget',
  value: 58,
  colour: '#2E5E9E'
}];
export function HeroArcs({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 320 320" aria-hidden="true" focusable="false" className={className} fill="none" data-id="element-349" data-mp="2e2v0lsuvzula">
      {[300, 258, 216, 174, 132, 90].map((radius, index) => <circle key={radius} cx="320" cy="0" r={radius / 2} stroke="#FF5C1A" strokeOpacity={0.42 - index * 0.05} strokeWidth={index % 2 === 0 ? 10 : 4} data-id="element-350" data-mp="2nzzmdrktlo1k" data-mpi={index} />)}
    </svg>;
}
function Donut() {
  const reduced = useReducedMotion();
  const circumference = 2 * Math.PI * 42;
  const value = 72;
  return <svg viewBox="0 0 100 100" className="h-[104px] w-[104px]" role="img" aria-label="Readiness score, 72 out of 100" data-id="element-351" data-mp="2snnhattim31p">
      <circle cx="50" cy="50" r="42" fill="none" stroke="#1E4374" strokeWidth="10" data-id="element-352" data-mp="2np3smlnjed5n" />
      <motion.circle cx="50" cy="50" r="42" fill="none" stroke="#FF5C1A" strokeWidth="10" strokeLinecap="round" transform="rotate(-90 50 50)" strokeDasharray={circumference} initial={reduced ? false : {
      strokeDashoffset: circumference
    }} animate={{
      strokeDashoffset: circumference * (1 - value / 100)
    }} transition={{
      duration: reduced ? 0 : 1.1,
      ease: 'easeOut',
      delay: 0.2
    }} data-id="element-353" data-mp="2jlxmde0fclz6" />
      <text x="50" y="55" textAnchor="middle" fontSize="20" fill="#F2F6FB" fontFamily="Sora, Ubuntu, sans-serif" data-id="element-354" data-mp="1vx4p9e82g82z">
        72
      </text>
    </svg>;
}
export function PlatformMock() {
  const reduced = useReducedMotion();
  return <div className="w-full max-w-[620px] overflow-hidden rounded-md border border-line shadow-[0_24px_60px_rgba(3,15,33,0.55)]" data-id="element-355" data-mp="1cb2vw7oiznki">
      <div className="flex items-center gap-2 border-b border-line bg-[#123761] px-3 py-2.5" data-id="element-356" data-mp="1hafrbgtgq2yp">
        {['#2E5E9E', '#2E5E9E', '#2E5E9E'].map((colour, index) => <span key={index} className="h-2 w-2 rounded-full" style={{
        backgroundColor: colour
      }} data-id="element-357" data-mp="17bzztcqiwroo" data-mpi={index} />)}
      </div>
      <div className="flex bg-panel" data-id="element-358" data-mp="1v1120i8rj6li">
        <div className="flex w-9 shrink-0 flex-col items-center gap-3.5 border-r border-line py-4" data-id="element-359" data-mp="1v22qboeshpl6">
          {Array.from({
          length: 8
        }).map((_, index) => <span key={index} className={`h-2 w-2 rounded-[2px] ${index === 1 ? 'bg-gold' : 'bg-[#1E4374]'}`} aria-hidden="true" data-id="element-360" data-mp="1lcaruj3kkcbf" data-mpi={index} />)}
        </div>
        <div className="min-w-0 flex-1 p-5 sm:p-6" data-id="element-361" data-mp="2e06kncq0pk2x">
          <p className="font-display text-[19px] text-ink sm:text-[21px]" data-id="element-362" data-mp="2dyc2u7a1m832">AI Readiness Predictor</p>
          <div className="mt-3 space-y-2" aria-hidden="true" data-id="element-363" data-mp="2it813p5vhrom">
            <span className="block h-2 w-full rounded-full bg-[#153864]" data-id="element-364" data-mp="7av6dufe03w7" />
            <span className="block h-2 w-3/5 rounded-full bg-[#153864]" data-id="element-365" data-mp="2dl61jqgm7tl" />
          </div>

          <div className="mt-6 grid gap-6 sm:grid-cols-2" data-id="element-366" data-mp="h2he3gsinku7">
            <div data-id="element-367" data-mp="h428n6etz3s2">
              <p className="text-[13px] text-muted" data-id="element-368" data-mp="c2wf56dcjchh">Readiness band</p>
              <p className="mt-2 font-display text-[30px] leading-none text-ink" data-id="element-369" data-mp="c3oaqh6y1a7r">
                Ready<span className="text-muted" data-id="element-370" data-mp="3kj80h68eoai2"> in parts</span>
              </p>
              <div className="mt-4 h-1.5 w-full overflow-hidden rounded-full bg-[#153864]" data-id="element-371" data-mp="3fkmzh4lbxmsk">
                <motion.span className="block h-full rounded-full bg-gold" initial={reduced ? false : {
                width: 0
              }} animate={{
                width: '72%'
              }} transition={{
                duration: reduced ? 0 : 0.9,
                ease: 'easeOut',
                delay: 0.15
              }} data-id="element-372" data-mp="3tjmmk7t71tmm" />
              </div>
              <div className="mt-1.5 flex justify-between text-[10px] text-muted" data-id="element-373" data-mp="14r0llu3qrtl8">
                {[0, 25, 50, 75, 100].map(tick => <span key={tick} data-id="element-374" data-mp="243byx2bk4uce">{tick}</span>)}
              </div>
              <p className="mt-3 text-[11px] text-muted" data-id="element-375" data-mp="245eoxmcpmnh4">Scored across 412 assessed organisations</p>
            </div>

            <div className="flex items-center gap-4" data-id="element-376" data-mp="2e1hvr5iibaae">
              <Donut data-id="element-377" data-mp="2e32s90odt3aw" />
              <ul className="space-y-1.5" data-id="element-378" data-mp="2dzf1uae8gx0e">
                {DIMENSIONS.map(dimension => <li key={dimension.label} className="flex items-center gap-2 text-[11px] text-body" data-id="element-379" data-mp="2iyi4jo6qqr57">
                    <span aria-hidden="true" className="h-2.5 w-2.5 shrink-0 rounded-[2px]" style={{
                  backgroundColor: dimension.colour
                }} data-id="element-380" data-mp="2mztmd7jdi82u" />
                    {dimension.label}: {dimension.value}%
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
}